module.exports = "<div class=\"item\">\n    <div class=\"row text-center text-large text-strong\">\n        <div class=\"col\" translate>\n            CHART_WORKLOAD_COLORS_MAP\n        </div>\n    </div>\n\n    <div class=\"chart-no-data\" ng-if=\"$ctrl.colors.length == 0\" translate>\n        CHART_WORKLOAD_COLORS_MAP_NO_DATA\n    </div>\n\n    <div id=\"chart-workload-colors-map-hs\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/chart-workload-colors-map/chart-workload-colors-map.html
// module id = 826
// module chunks = 0